// extracted by mini-css-extract-plugin
export default {"card":"Card_card__3kgha","card_header":"Card_card_header__RPayR","title":"Card_title__D4Q-i"};